export default __webpack_public_path__ + "8634bf894e51a19a389555019c4fdbdf.png";